export default "__VITE_ASSET__10wLPKj7__"